export default __webpack_public_path__ + "static/media/img-6.f60eea40.jpg";